import { createStyles } from '@mantine/core'

export default createStyles((theme) => ({
  wrap: {
    [`@media (max-width: ${theme.breakpoints.md}px)`]: {
      height: '100%',
      padding: '0px 32px',
    },
  },
  wrapPopup: {
    [`@media (max-width: ${theme.breakpoints.md}px)`]: {
      height: '100%',
      padding: '0px',
    },
  },
  background: {
    background: 'lightgrey',
    padding: '16px',
    gap: '0',
    textAlign: 'center',
  },
  title: {
    fontSize: '16px',
  },
  link: {
    fontSize: '16px',
    color: 'primary',
  },
}))
